import RegisterApp from '../../vue/apps/register';

(() => {
	'use strict';

	$(document).ready(() => {    
		const registerAppEl = document.getElementById('registerApp');

		if(registerAppEl){
			new RegisterApp(registerAppEl);
        }
	});
})();
